import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetAllThreadsRequestAction {
  data: {
    traderId: number;
    interventionId: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getAllThreadsRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IGetAllThreadsRequestAction>,
) {
  draft.getAllThreads.config.isLoading = true;
}

export default getAllThreadsRequest;
